import * as RadixDialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Button } from "./Button";
import { Row, Stack } from "./Stack";

export interface DialogProps {
  abierto: boolean;
  onCambio: (abierto: boolean) => void;
  titulo: string;
  descripcion?: string;
  /** "amplio" para contenido ancho, como una foto. */
  ancho?: "normal" | "amplio";
  children: ReactNode;
}

/** Modal accesible (Radix). En el celular sube desde abajo; en la compu queda centrado. */
export function Dialog({ abierto, onCambio, titulo, descripcion, ancho = "normal", children }: DialogProps) {
  return (
    <RadixDialog.Root open={abierto} onOpenChange={onCambio}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-texto/40 backdrop-blur-[2px]" />
        <RadixDialog.Content
          className={cn(
            "fixed inset-x-0 bottom-0 z-50 max-h-[90dvh] overflow-y-auto rounded-t-tarjeta bg-superficie p-5 shadow-flotante focus:outline-none",
            "sm:inset-auto sm:left-1/2 sm:top-1/2 sm:w-full sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-tarjeta",
            ancho === "amplio" ? "sm:max-w-3xl" : "sm:max-w-md",
          )}
        >
          <Stack espacio={4}>
            <Row justificar="entre" alinear="inicio">
              <RadixDialog.Title className="text-titulo font-light tracking-tight">{titulo}</RadixDialog.Title>
              <RadixDialog.Close asChild>
                <Button variante="fantasma" tamanio="sm" aria-label="Cerrar">
                  ✕
                </Button>
              </RadixDialog.Close>
            </Row>
            {descripcion && <RadixDialog.Description className="text-texto-suave">{descripcion}</RadixDialog.Description>}
            {children}
          </Stack>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
